import { valibotResolver } from '@hookform/resolvers/valibot';
import { nonEmpty, object, pipe, string, custom, forward, partialCheck } from 'valibot';

export const CHANGE_PASSWORD_FIELDS = {
  OLD_PASSWORD: 'old_password',
  PASSWORD: 'password',
  CONFIRM_PASSWORD: 'confirm_password',
};

const checkPasswordValue = (value) => {
  const passwordPattern = /^(?=.*[A-Za-z])(?=.*\d)(?=.*[@$!%*#?&_])[A-Za-z\d@$!%*#?&_]{8,}$/i;

  return passwordPattern.test(value);
};

export const schemaChangePassword = valibotResolver(
  pipe(
    object({
      [CHANGE_PASSWORD_FIELDS.OLD_PASSWORD]: pipe(string(), nonEmpty('This field is required.')),
      [CHANGE_PASSWORD_FIELDS.PASSWORD]: pipe(
        string(),
        nonEmpty('This field is required.'),
        custom(checkPasswordValue, 'Password must be at least 8 characters with at least 1 number, 1 special character')
      ),
      [CHANGE_PASSWORD_FIELDS.CONFIRM_PASSWORD]: pipe(string(), nonEmpty('This field is required.')),
    }),
    forward(
      partialCheck(
        [[CHANGE_PASSWORD_FIELDS.PASSWORD], [CHANGE_PASSWORD_FIELDS.CONFIRM_PASSWORD]],
        (input) => input.password === input.confirm_password,
        'Confirm Password. Password must be same.'
      ),
      [CHANGE_PASSWORD_FIELDS.CONFIRM_PASSWORD]
    )
  )
);


export const changePasswordDefaultValue = {
  [CHANGE_PASSWORD_FIELDS.OLD_PASSWORD]: '',
  [CHANGE_PASSWORD_FIELDS.PASSWORD]: '',
  [CHANGE_PASSWORD_FIELDS.CONFIRM_PASSWORD]: '',
};
